<template>
  <v-app>
    <v-container>
      <v-layout>
        <v-btn color="blue darken-1" dark v-if="isAdmin"
               @click="create()">新增公告</v-btn>
      </v-layout>
      <v-progress-linear height="3px"
                         v-show="loading" color="primary" indeterminate></v-progress-linear>
      <v-layout xs12 lg8 class="mt-2"
                v-for="notice in list" :key="notice.noticeId">
        <v-flex>
          <v-card>
            <v-card-title>
              <span class="headline" @click="detail(notice)">{{notice.title}}</span>
              <v-spacer></v-spacer>
              <span class="subheading">發佈日期：{{notice.createdDate}}</span>
            </v-card-title>
            <v-divider></v-divider>
<!--            <v-card-text>-->
<!--              <span style="word-wrap:break-word;">-->
<!--                {{notice.content}}-->
<!--              </span>-->
<!--            </v-card-text>-->
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="red darken-1" dark v-if="isAdmin" @click="removeTip(notice)">刪除</v-btn>
              <v-spacer></v-spacer>
              <div v-if="isAdmin">
                <v-btn color="blue darken-1" dark @click="editor(notice)">編輯</v-btn>
                <v-btn color="blue darken-1" dark @click="detail(notice)">明細</v-btn>
              </div>
              <div v-else>
                <v-btn color="blue darken-1" dark @click="detail(notice)">明細</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

<!--    <v-dialog v-model="edit.visible"-->
<!--              max-width="100%"-->
<!--              fullscreen>-->

<!--    </v-dialog>-->

    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.content"
                :show-cancel="messageDialog.showCancel"
                @confirmEvent="messageDialog.confirm"
                @cancelEvent="messageDialog.cancel"></alert-view>
  </v-app>
</template>

<script>
  import {getNow} from '../utils/tool';
  import MobileDetect from 'mobile-detect';
  import { mapActions, mapGetters } from 'vuex';
  const md = new MobileDetect(window.navigator.userAgent);
  import AlertView from '@/components/AlertView';
  export default {
    name: 'NoticeList',
    components: {
      AlertView,
    },
    data(){
      return {
        editorOption: {
        },
        loading: false,
        saveLoading: false,
        list: [],
        edit: {
          visible: false,
          valid: false,
        },
        editedIndex: -1,
        editedItem: {
          title:'',
          content:'',
          owner:'',
          enable: true
        },
        messageDialog: {
          visible: false,
          title: '',
          content: '',
          showCancel: true,
          confirm: ()=>{},
          cancel:()=>{},
        },
      }
    },
    created() {
      this.loadData();
    },

    computed: {
      ...mapGetters(['getUserInfo']),
      formTitle() {
        return this.editedIndex === -1 ? '新增' : '編輯'
      },
      dialogKeys() {
        return [
          { value: 'title', text: '標題', sortable: true  ,required: true},
          { value: 'content', text: '內容', sortable: true  ,required: true},
        ]
      },
      isAdmin() {
        return this.getUserInfo.authority === 'admin';
      }
    },
    methods: {
      ...mapActions(['getNoticeList', 'createNotice', 'saveNotice', 'deleteNotice']),
      async loadData(){
        this.loading = true;
        const res = await this.getNoticeList({ limit: 10 });
        this.loading = false;
        if (res){
          console.log(`loadData == ${JSON.stringify(res.data)}`);
          if (res.data.statusCode === 0){
            this.list = res.data.data;
          }
        }
      },
      create(){
        this.$router.push({ path: 'NoticeDetailView', query: { id:'', edit: 1 }})
      },
      editor(notice){
        // this.editedItem = notice;
        // this.editedIndex = 1;
        // this.edit.visible = true;

        this.$router.push({ path: 'NoticeDetailView', query: { id:notice.noticeId, edit: 1 }})
      },
      detail(notice){
        this.$router.push({ path: 'NoticeDetailView', query: { id:notice.noticeId, edit: 0 }})
      },
      removeTip(notice){
        this.showDialog(true , '提示', '確認刪除？',true ,()=>{
          this.messageDialog.visible = false;
          this.remove(notice);
        }, ()=>{
          this.messageDialog.visible = false;
        });
      },
      async remove(notice){
        this.saveLoading = true;
        const res = await this.deleteNotice({ noticeId: notice.noticeId });
        this.saveLoading = false;
        if (res){
          if (res.data.statusCode === 0){
            this.showDialog(true , '成功', res.data.message, false
              , this.closeDialog, this.closeDialog);
            this.loadData();
          } else {
            this.showDialog(true , '錯誤', res.data.message, false
              , this.closeDialog, this.closeDialog);
          }
        } else {
          this.showDialog(true , '錯誤', '刪除失敗', false
            , this.closeDialog, this.closeDialog);
        }
      },
      showDialog(visible, title, content, showCancel, confirm, cancel) {
        this.messageDialog.visible = visible;
        this.messageDialog.title = title;
        this.messageDialog.content = content;
        this.messageDialog.showCancel = showCancel;
        this.messageDialog.confirm = confirm;
        this.messageDialog.cancel = cancel;
      },
      closeDialog(){
        this.messageDialog.visible = false
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/NoticeList.vue